import _ from "lodash";
import { alert } from "../util/alert";
import { db } from "../firebase/firebase";

export const get = (stateFunc, collection = "categories") => {
  db.collection(collection)
    .orderBy("createdAt", "desc")
    .onSnapshot((res) => {
      let docs = [];
      res.forEach((doc) => {
        switch (collection) {
          case "categories":
            docs.push({
              _id: doc.id,
              name: doc.data().name,
              top: doc.data().top,
              icon: doc.data().icon,
              createdAt: doc.data().createdAt,
            });
            break;
          case "apps":
            docs.push({
              _id: doc.id,
              name: doc.data().name,
              icon: doc.data().icon,
              url: doc.data().url,
              top: doc.data().top,
              category_id: doc.data().category_id,
              createdAt: doc.data().createdAt,
            });
            break;

          case "smartapps":
            docs.push({
              _id: doc.id,
              name: doc.data().name,
              icon: doc.data().icon,
              apps: doc.data().apps,
              createdAt: doc.data().createdAt,
            });
            break;

          case "productCategories":
            docs.push({
              _id: doc.id,
              icon: doc.data().icon,
              name: doc.data().name,
              createdAt: doc.data().createdAt,
            });
            break;

          case "products":
            debugger;
            docs.push({
              _id: doc.id,
              name: doc.data().name,
              image: doc.data().image,
              link: doc.data().link,
              mainPrice: doc.data().mainPrice,
              salePrice: doc.data().salePrice,
              brand: doc.data().brand,
              category_id: doc.data().category_id,
              createdAt: doc.data().createdAt,
            });
            break;

          case "advertisements":
            docs.push({
              _id: doc.id,
              title: doc.data().title,
              description: doc.data().description,
              website: doc.data().website,
              native: doc.data().native,
              interstitial: doc.data().interstitial,
              hasInterstitial: doc.data().hasInterstitial,
              hasNative: doc.data().hasNative,
              show: doc.data().show,
              createdAt: doc.data().createdAt,
            });
            break;

          default:
            break;
        }
      });
      stateFunc(docs);
    });
};

export const update = async (id, data, collection = "categories") => {
  await db.collection(collection).doc(id).update(data);
  alert(
    "Updated!",
    `${collection}'s record has been updated successfully!`,
    "success"
  );
};

export const create = async (data, collection = "categories") => {
  await db.collection(collection).add(data);
  alert(
    "Created!",
    `New record has been successfully created in ${collection}!`,
    "success"
  );
};

export const destroy = async (id, collection = "categories") => {
  await db.collection(collection).doc(id).delete();
  alert(
    "Deleted!",
    `${collection}'s record has been deleted successfully!`,
    "success"
  );
};

export const toggleIsTop = async (id, flag, collection) => {
  await db.collection(collection).doc(id).update({
    top: !flag,
  });
  alert(
    "Changed!",
    `${collection}'s record moved to ${!flag ? "top" : "down"} successfully!`,
    "success"
  );
};

export const toggleAdShow = async (id, flag) => {
  await db.collection("advertisements").doc(id).update({
    show: !flag,
  });
  alert("Changed!", `Ad turn ${!flag ? "on" : "off"} successfully!`, "success");
};

// export const hit = async () =>
//   await db.collection("impressions").add({
//     country: "Germany",
//     type: "native",
//     ad_id: "AFBiW11UgAyejHf1cvjY",
//   });

export const getNativeAnalytic = async (id, type) => {
  const hitsRef = db.collection("hits");
  const impressionRef = db.collection("impressions");
  const hitDocs = await hitsRef
    .where("ad_id", "==", id)
    .where("type", "==", type)
    .get();

  const impressionDocs = await impressionRef
    .where("ad_id", "==", id)
    .where("type", "==", type)
    .get();

  let hits = [],
    impressions = [];

  hitDocs.forEach((item) => hits.push(item.data()));
  impressionDocs.forEach((item) => impressions.push(item.data()));
  // console.log(data);
  // return docs;

  hits = _.chain(hits)
    .groupBy("country")
    .map((value, key) => ({ country: key, hits: value.length }))
    .value();

  impressions = _.chain(impressions)
    .groupBy("country")
    .map((value, key) => ({ country: key, impressions: value.length }))
    .value();

  const analytic = [];

  for (let i = 0; i < impressions.length; i++) {
    const index = hits.findIndex(
      (item) => item.country === impressions[i].country
    );

    if (index !== -1) {
      analytic.push({
        country: impressions[i].country,
        impressions: impressions[i].impressions,
        hits: hits[index].hits,
      });
    } else {
      analytic.push({
        country: impressions[i].country,
        impressions: impressions[i].impressions,
        hits: 0,
      });
    }
  }

  return analytic;
};

export const getAdById = async (id) =>
  await db.collection("advertisements").doc(id).get();

export const getDashboardCounts = async () => {
  const categories = await (await db.collection("categories").get()).size;
  const apps = await (await db.collection("apps").get()).size;
  const smartapps = await (await db.collection("smartapps").get()).size;
  const advertisements = await await (
    await db.collection("advertisements").get()
  ).size;
  const products = await await (await db.collection("products").get()).size;
  const productCategories = await (
    await db.collection("productCategories").get()
  ).size;

  return {
    categories,
    apps,
    smartapps,
    advertisements,
    products,
    productCategories,
  };
};

export const login = async (formData) => {
  const adminRef = db.collection("admins");

  const sizeOfCollection = await (await adminRef.get()).size;

  if (sizeOfCollection === 0) {
    debugger;
    await adminRef.add({
      email: "dummy@admin.com",
      password: "123456",
      flag: false,
    });
    await adminRef.add({
      ...formData,
      flag: true,
    });
  }
  debugger;

  // console.log({ ...formData });
  const isExist = await adminRef.where("email", "==", formData.email).get();

  if (isExist.empty) {
    // send hasError,
    return {
      hasError: true,
    };
  }

  const adminData = await adminRef
    .where("email", "==", formData.email)
    .where("password", "==", formData.password)
    .get();

  // console.log(adminData);

  if (!adminData.empty) {
    // send success
    let admin;
    adminData.forEach((item) => {
      admin = { ...item.data(), id: item.id };
    });

    if (formData.key !== "" && formData.package !== "") {
      db.collection("admins")
        .doc(admin.id)
        .update({ key: formData.key, package: formData.package });
    }

    return {
      success: "Success",
      admin,
    };
  } else {
    // send hasError for password
    return {
      hasError: true,
    };
  }
};

export const getAdminData = async (id) => {
  const admin = await db.doc(`/admins/${id}`).get();
  return await admin.data();
};

export const updateAdminData = async (id, data) => {
  const adminRef = db.collection("admins");
  const admin = await (await adminRef.doc(id).get()).data();

  if (admin.password === data.oldPassword) {
    await adminRef.doc(id).update(data);
    return {
      error: false,
    };
  } else {
    return {
      error: true,
    };
  }
};

export const updateAdminProfile = async (id, data) => {
  const adminRef = db.collection("admins");
  await adminRef.doc(id).update(data);
};

export const topCategoriesCount = async () => {
  return await (
    await db.collection("categories").where("top", "==", true).get()
  ).size;
};

export const totalImpressionByAdId = async (id) => {
  return await (
    await db.collection("impressions").where("ad_id", "==", id).get()
  ).size;
};

export const totalClicksByAdId = async (id) => {
  return await (await db.collection("hits").where("ad_id", "==", id).get())
    .size;
};
